<div class="row" [class.last]="last()">
  <div class="icon">
    <img src="assets/icons/icon-coupon.svg" alt="">
  </div>
  <div class="label">Coupon Code</div>
  <div class="chevron">
    <ion-icon name="chevron-forward"></ion-icon>
  </div>
</div>